'use client'

import React from 'react'

import {ProductAttribute} from '@/src/core/domain/entities/product'
import {isProductViewModelWithVariants} from '@/src/entities/product/helpers/validators'
import {OfferValue} from '@/src/features/catalog'
import * as UI from '@/src/features/catalog/product-list/product-list-item.styled'
import {observer} from 'mobx-react'
import {useProductListItem} from '@/src/features/catalog/product-list/product-list-item.provider'

export const ProductAttributeValuesContainer = observer(
  ({attribute}: {attribute: ProductAttribute}) => {
    const productListItemVM = useProductListItem()

    if (!productListItemVM) throw Error('Product item view model does not found in list')

    return (
      <>
        {isProductViewModelWithVariants(productListItemVM) &&
          // productHasManyVariants(productListItemVM.product) &&
          productListItemVM.variants.getAttributeValues(attribute.code).map(attributeValue => (
            <UI.ProductPropertyValueItem
              as={OfferValue}
              key={`property-${productListItemVM.product.id}-${attribute.code}-${attributeValue.value}`}
              active={attributeValue.active}
              disabled={attributeValue.disabled}
              onChange={() =>
                productListItemVM.variants.setSelectedAttribute(
                  attribute.code,
                  attributeValue.value,
                )
              }>
              {attributeValue.title}
            </UI.ProductPropertyValueItem>
          ))}
      </>
    )
  },
)
